<template>
    <template v-if="isExportLayout && isNoActionSet">
        <ColorBadge
            color="#adadad"
            :text="t('common.conditionStatus.noAction.label')"
            small
        />
    </template>
    <div v-else-if="!isExportLayout" class="no-action-category">
        <HorizontalButton
            v-tooltip="t('common.conditionStatus.noAction.tooltip.description')"
            :text="t('common.conditionStatus.noAction.label')"
            :icon-name="isNoActionSet ? 'check-square' : 'square'"
            :disabled="!canSetAsNoAction"
            @click="noActionCategoryModal?.openModal()"
        />
        <template v-if="isNoActionSet && noActionComponent">
            <MessageSquareText
                v-tooltip="{
                    content: `
                        ${t('common.conditionStatus.noAction.tooltip.title')}
                        <br><br>
                        ${noActionComponent.comment}
                        <br/><br/>
                        ${noActionComponent.createdBy} | ${formattedDate}
                    `,
                    distance: 10,
                    placement: 'bottom-start',
                    html: true,
                }"
                class="no-action-category__comment-icon"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
import HorizontalButton from '@/components/buttons/HorizontalButton.vue'
import { NoActionComponentDto } from '@/api/generated/HCA'
import { useNoActionCategoryModal } from '@/pages/transformers/condition-status/modals/no-action-category/useConditionStatusNoActionCategoryModal'
import { MessageSquareText } from 'lucide-vue-next'
import { computed } from 'vue'
import { format } from 'date-fns'
import { useI18n } from 'vue-i18n'
import { DATE_TIME_FORMAT } from '@/utils/date-utils'
import ColorBadge from '@/components/badge/ColorBadge.vue'
import { usePermissions } from '@/composables/usePermissions'
import { ComponentType } from '@/configuration/component/component-types'

const props = defineProps<{
    isNoActionSet: boolean
    noActionComponent?: NoActionComponentDto
    isExportLayout?: boolean
    componentType?: ComponentType
}>()

const { t } = useI18n()
const noActionCategoryModal = useNoActionCategoryModal()

const { userPermissions } = usePermissions()

const canSetAsNoAction = computed(() => {
    if (props.componentType === ComponentType.Transformer) {
        return userPermissions.value.canSetTransformerAsNoAction
    } else if (props.componentType === ComponentType.Generator) {
        return userPermissions.value.canSetGeneratorAsNoAction
    }
    return false
})

const formattedDate = computed(() => {
    if (!props.noActionComponent?.createdAt) {
        return ''
    }

    return format(new Date(props.noActionComponent.createdAt), DATE_TIME_FORMAT)
})
</script>

<style scoped lang="scss">
.no-action-category {
    display: flex;
    align-items: center;
    gap: 16px;

    // .button {
    //     font-weight: normal;
    //     color: rgb(var(--pbl-text));
    // }

    &__comment-icon {
        cursor: pointer;
        color: $pbl-text-muted;

        &:focus {
            outline: none;
        }
    }
}
</style>
